<script lang="ts" setup>
import { getPersonBySlug } from '~/queries/composer'
const { slug } = useResourceSlug()
const { formatToFullDate } = useFullDateFormater()
const { data, pending, error } = await useAsyncData(
  `/composer/${slug}/videos`,
  () =>
    execQuery(() => getPersonBySlug('videos'), {
      slug,
    })
)
const composer = computed(() => {
  if (pending.value || error.value) return null
  return data.value.data.personBySlug
})
function formatVideo(video) {
  if (!video) return null
  return {
    subtitle: video.description,
    excerpt: `${video.timestamp ? formatToFullDate(video.timestamp) : ''} ${
      video.duration ?? ''
    }`,
    ...video,
  }
}

const title = computed(() => {
return  `Videos - ${composer.value?.firstName} ${composer.value?.lastName}`
})

const description = computed(() => {
return  `La liste des videos du compositeur ${composer.value?.firstName} ${composer.value?.lastName}`
})

useHead({
  title,
  meta: [
    {
      name: 'description',
      content:description,
    }
  ],
})

useSeoMeta({
  title,
  ogTitle: title,
  description,
  ogDescription: description,
  ogImage: composer.value?.photo?.getUrl,
  twitterCard: 'summary',
})
</script>
<template>
  <DetailComposer
    :resume="composer?.resume"
    :composer="composer"
    active-outline-id="video"
  >
    <template #typeIcon>
      <div
        class="m-14 hidden h-40 w-40 shrink-0 items-center justify-center bg-white sm:flex lg:h-60 lg:w-60"
        v-if="composer?.photo?.getUrl"
      >
        <div class="relative">
          <img
            :src="composer?.photo?.getUrl"
            :alt="
              'biography of ' + composer?.firstName + ' ' + composer?.lastName
            "
            class="h-full w-full object-cover sm:p-0"
          />
          <span
            v-if="composer?.copyrights"
            class="absolute right-1 bottom-0 text-white"
            >© {{ composer?.copyrights }}</span
          >
        </div>
      </div>
    </template>
    <template #prose>
      <div class="pt-6 md:pt-0">
        <p class="text-mobile-lg text-shade-500 md:hidden">
          {{ $t('search.total_result', composer?.videos?.length) }}
        </p>
        <div class="divide-y divide-shade-200">
          <ListResource
            v-for="(result, i) in composer?.videos?.map(formatVideo)"
            :key="i"
            :resource="result"
            :hideIcon="true"
            :minified="true"
          />
        </div>
      </div>
    </template>
  </DetailComposer>
</template>
